import { forwardRef, type Ref, type SVGProps } from "react";
const IconLiveBroadcastOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.975 15.914c0 3-1 6-2.8 8.4-.6.8-1.3 1.6-2.1 2.3-.4.3-1 .3-1.3-.1-.4-.4-.4-1 0-1.4l.1-.1c5-4.3 5.6-11.9 1.3-17l-.6-.6c-.2-.2-.4-.4-.7-.6-.4-.4-.5-1-.1-1.4l.1-.1c.4-.4 1-.4 1.4-.1.3.2.5.5.8.7.5.5.9 1 1.3 1.5 1.6 2.5 2.6 5.5 2.6 8.5m-21.8 10.6c-.3.3-.9.4-1.3 0-.8-.7-1.5-1.4-2.1-2.3-3.7-5-3.7-11.8 0-16.7.4-.5.8-1.1 1.3-1.5.3-.3.5-.5.8-.7.4-.3 1-.3 1.4.1s.4 1 0 1.4l-.1.1c-.3.1-.5.3-.7.5-4.7 4.7-4.7 12.3 0 17 .2.2.4.4.7.6.4.4.4 1 0 1.5.1-.1 0-.1 0 0" />
    <path d="M23.975 15.914c0 1.4-.4 2.8-1.1 4.1-.5.9-1.2 1.7-2.1 2.3-.4.3-1 .3-1.3-.1-.4-.4-.4-1 0-1.4l.1-.1c2.3-1.7 3.1-4.8 1.8-7.4-.3-.6-.7-1.2-1.2-1.7-.2-.2-.4-.4-.7-.6-.4-.3-.5-.9-.2-1.4l.1-.1c.4-.4.9-.4 1.3-.1.3.2.6.5.9.7.5.5.9 1 1.2 1.6q1.2 2.1 1.2 4.2m-11.5 6.3c-.4.4-1 .4-1.4.1-.8-.6-1.5-1.4-2.1-2.3-1.5-2.5-1.5-5.6 0-8.1.3-.6.8-1.1 1.2-1.6.3-.3.6-.5.9-.7.4-.3 1-.3 1.3.1.4.4.4 1 0 1.4l-.1.1c-.2.2-.5.4-.7.6-1.8 1.8-2.3 4.5-1.2 6.8.4.9 1 1.6 1.8 2.2.4.3.5.9.2 1.3.2 0 .2 0 .1.1m5.5-6.3c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.5 0 1.1.2 1.4.6.4.4.6.9.6 1.4" />
  </svg>
);
const ForwardRef = forwardRef(IconLiveBroadcastOutlineSVG);
ForwardRef.displayName = "IconLiveBroadcastOutline";
export { ForwardRef as IconLiveBroadcastOutline };
